export default class CreateAuthZeroMemberModel {
    OrganizationId = null
    Email = null
    Password = null
    GivenName = null
    FamilyName = null
    Name = null
    RoleId = null
    DualloOrganizationId = null

    constructor(orgId, email, first_name, last_name, roleId, dualloOrgId) {
        this.OrganizationId = orgId;
        this.Email = email;
        this.GivenName = first_name;
        this.FamilyName = last_name;
        this.Name = first_name + " " + last_name;
        this.Password = CreateAuthZeroMemberModel.generatePassword();
        this.RoleId = roleId;
        this.DualloOrganizationId = dualloOrgId;
    }

    static generatePassword(length = 12) {
        const chars =
            'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()-_=+[]{}'
        let result = ''
        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length))
        }
        return result
    }
}